import { AlertTriangle } from "lucide-react";

interface ErrorStateProps {
  message: string;
  onRetry?: () => void;
}

export function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <div className="text-center py-12">
      <div className="inline-flex bg-red-500/10 rounded-2xl p-3 mb-4">
        <AlertTriangle size={26} className="text-red-500" />
      </div>
      <h3 className="text-lg font-semibold text-text">Si è verificato un errore</h3>
      <p className="text-sm text-muted-foreground mt-2">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 px-4 py-2 bg-brand text-white rounded-lg text-sm hover:bg-brand-dark transition-colors"
        >
          Riprova
        </button>
      )}
    </div>
  );
}
